import { actions, types } from './requests'
export const GETCOMMAND_TYPES = {
    ...types('GETCOMMAND'),
}
export const GETCOMMAND_ACTIONS = {
    ...actions('GETCOMMAND'),
}